export default "__VITE_ASSET__D00oeDar__"